import { createRoutine } from 'redux-saga-routines';
import { ROLES_LIST } from './types';

// eslint-disable-next-line import/prefer-default-export
export const listRoles = createRoutine(ROLES_LIST);
